import React, { createContext, useContext, useState } from "react";
import { BetDetails } from "../models/MyBetModel.tsx";

interface IBetContext {
    bets: BetDetails[],
    updateBet: { (bet: BetDetails): void },
    deleteBet: { (bet: BetDetails | String): void },
    clearBets: Function,
    addBet: { (bet: BetDetails): void };
    setBets: React.Dispatch<React.SetStateAction<BetDetails[]>>;
    updateBetLive: { (bet: BetDetails): void },
    upsertBet: { (bet: BetDetails): void },
    useFreePlay: boolean,
    setUseFreePlay: React.Dispatch<React.SetStateAction<boolean>>;
}
const BetContext = createContext<IBetContext | undefined>(undefined);

// Create the provider component
export const BetProvider = ({ children }: { children: React.ReactNode }) => {
    // State for the context
    const [bets, setBets] = useState<BetDetails[]>([]);
    const [useFreePlay, setUseFreePlay] = useState(false);

    /**
     * 
     * @param bet the bet to update / add
     * @returns BetDetails[] updatedQuee | the updated quee
     */

    const updateBet = (bet: BetDetails) => {

        const betToUpdate = bets.find(existingBet => existingBet.id_selection === bet.id_selection);
        if (betToUpdate) {
            const updatedBets = bets.map(existingBet =>
                existingBet.id_selection === bet.id_selection ? bet : existingBet
            );
            setBets(updatedBets);
        }
    }

    const deleteBet = (bet: BetDetails | String) => {
        if (typeof bet === 'string') {
            const betPool = bets.filter(existingBet => existingBet.id_selection !== bet);
            setBets(betPool);
            return;
        }

        const betPool = bets.filter(existingBet => existingBet.id_selection !== (bet as BetDetails)?.id_selection);

        setBets(betPool);
    };

    const addBet = (bet: BetDetails) => {
        setBets(prevBets => [...prevBets, bet]);
    }

    const clearBets = () => {
        setBets([]);
    };

    const updateBetLive = (bet: BetDetails) => {
        const updatedBets = bets.map(existingBet =>
            existingBet.gameId === bet.gameId &&
                existingBet.odd?.market_id === bet.odd?.market_id &&
                existingBet.odd?.selection_line === bet.odd?.selection_line
                ? bet
                : existingBet
        );

        setBets(updatedBets);
    };

    const upsertBet = (bet: BetDetails) => {
        setBets(prevBets => {
            const exists = prevBets.find(b => b.id_selection === bet.id_selection);

            if (exists) {
                return prevBets.map(b =>
                    b.id_selection === bet.id_selection ? bet : b
                );
            }

            return [...prevBets, bet];
        });
    };


    const value: IBetContext = { bets, updateBet, deleteBet, clearBets, addBet, setBets, updateBetLive, upsertBet, useFreePlay, setUseFreePlay };

    return <BetContext.Provider value={value}>
        {children}
    </BetContext.Provider>;
};

export const useBetContext = (): IBetContext => {

    const context = useContext(BetContext);

    if (!context) {
        throw new Error("useBetContext must be used within a BetProvider");
    }

    return context;
};